<section>
  <div class="report-tab">
    <ul class="nav nav-pills" role="tablist">
      <li class="nav-item" role="presentation">
        <span class="nav-link active">Sales Productivity Report</span>
      </li>
    </ul>
  </div>

  <!-- Report filter-->
  <div class="payment-report-filters d-flex flex-wrap gap-2 mt-3 mb-2">
    <div class="filter-wrapper">
      <div class="dropdown stores" style="width: unset !important">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text">{{ storeName }}</small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 100%"
        >
          <ul>
            <li style="border-bottom: 1px solid #d4d4d4">
              <a class="dropdown-item">
                <div class="form-check d-flex" style="cursor: pointer">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                    [checked]="headerCheckboxSelected"
                    (click)="toggleAllCheckboxes()"
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    Select all Stores ({{ stores.length ? (stores.length |
                    number) : 0 }})
                  </label>
                </div>
              </a>
            </li>
            <li *ngFor="let str of stores; let i = index">
              <a class="dropdown-item">
                <div class="form-check d-flex" style="cursor: pointer">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                    [value]="str.storeId"
                    [checked]="headerCheckboxSelected"
                    [value]="str.isSelected"
                    (change)="setFilterNames(str, 2)"
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    {{ str.storeName }}
                  </label>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="filter-wrapper">
      <div class="dropdown departments" style="width: unset !important">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text">{{ deptName }}</small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 100%"
        >
          <ul>
            <!-- Select All Option -->
            <li style="border-bottom: 1px solid #d4d4d4">
              <a class="dropdown-item">
                <div class="form-check d-flex" style="cursor: pointer">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="selectAllCheckbox"
                    [checked]="headerDeptCheckboxSelected"
                    (change)="toggleAllDepartments()"
                  />
                  <label class="form-check-label" for="selectAllCheckbox">
                    Select all Departments ({{ mainDepartmentList.length ?
                    mainDepartmentList.length : 0 }})
                  </label>
                </div>
              </a>
            </li>

            <!-- Department List -->
            <li *ngFor="let dept of mainDepartmentList; let i = index">
              <a class="dropdown-item">
                <div class="form-check d-flex" style="cursor: pointer">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [id]="'deptCheckbox' + i"
                    [checked]="dept.isSelected"
                    (change)="setFilterNames(dept, 1)"
                  />
                  <label class="form-check-label" [for]="'deptCheckbox' + i">
                    {{ dept.departmentDescr }}
                  </label>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="filter-wrapper" [ngClass]="{ disabled: disableCategory }">
      <div class="dropdown" style="width: unset !important">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text">{{ categoryName }}</small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 100%"
        >
          <ul>
            <li (click)="selectAllcategories()">
              <a class="dropdown-item">All Categories</a>
            </li>
            <li *ngFor="let ctg of categorieslist">
              <a class="dropdown-item" (click)="setFilterNames(ctg, 3)"
                >{{ ctg.categoryName }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--week color -->

    <div class="filter-wrapper" *ngIf="showWeekColor">
      <div class="dropdown stores" style="width: unset !important">
        <div class="report-type" data-bs-toggle="dropdown">
          <small class="filter-text"> {{ weekColor }} </small>
          <button
            class="btn text-nowrap"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
          >
            <img src="assets/pos/products/ic_upDown.svg" />
          </button>
        </div>

        <div
          class="dropdown-menu p-2 mt-1"
          aria-labelledby="dropdownMenuButton"
          style="width: 100%"
        >
          <ul>
            <li>
              <a class="dropdown-item">All Week Colors</a>
            </li>
            <li
              *ngFor="let wk of weekColorsList"
              (click)="setFilterNames(wk, 5)"
            >
              <a class="dropdown-item" [style.backgroundColor]="wk.color"
                >{{ wk.displayName }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="filter-wrapper date-range"
      (click)="openCalender()"
      style="cursor: pointer"
    >
      <div class="report-type ps-0" style="width: 18rem">
        <button
          class="btn text-nowrap"
          type="button"
          style="
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            border-right: 1px solid #d4d4d4;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          "
        >
          <img src="assets/pos/products/ic_leftArrow.svg" />
        </button>
        <input
          type="text"
          name="daterangeInput"
          daterangepicker
          #dateRange
          [options]="options"
          (selected)="selectedDate($event)"
          style="max-width: 17rem"
        />
        <button class="btn text-nowrap" type="button">
          <img src="assets/pos/products/ic_rightArrow.svg" />
        </button>
      </div>
    </div>
    <div
      class="create-btn run-report-btn c-pt"
      [class.is-loading]="isLoading"
      (click)="runReport()"
    >
      <span class="run-spinner" *ngIf="isLoading"></span>
      <img
        *ngIf="!isLoading"
        src="assets/Pos-Catalog/jam_refresh.svg"
        class="run-icon"
        alt=""
      />
      {{ isLoading ? "Running…" : "Run Report" }}
    </div>
    <!-- more options dropdown -->
    <div
      class="tab-action-container bg-white ms-2"
      style="border-radius: 8px; height: 2.6rem"
    >
      <div class="dropdown custom-left">
        <button
          class="btn dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          id="removeContent"
          matTooltip="More Options"
          matTooltipPosition="above"
          matTooltipClass="raised-tooltip"
        >
          <img src="assets/Pos-Catalog/ri_more-fill.svg" />
        </button>
        <div
          class="dropdown-menu h-auto mt-3"
          id="firstDropdown"
          style="width: 12rem"
        >
          <div class="second-part">
            <ul class="dropdown-list list-unstyled mb-0">
              <li
                (click)="
                  reportHasRun &&
                    !noDataFound &&
                    salePerProducerReportData.length &&
                    exportReport()
                "
                style="cursor: pointer"
                [class.disabled]="!reportHasRun || noDataFound || !salePerProducerReportData.length"
              >
                <a class="dropdown-item"
                  ><img
                    class="me-3"
                    src="/assets/Pos-Catalog/arrowup.svg"
                  />Export Report</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- empty state: shown until the report is run -->
  <div class="report-empty-state" *ngIf="!reportHasRun">
    <img src="assets/dashboard/noData.svg" alt="" />
    <h5>Ready when you are</h5>
    <p>
      Adjust the filters above, then click <strong>Run Report</strong> to
      generate the sale-per-producer report.
    </p>
    <div class="create-btn run-report-btn c-pt" (click)="runReport()">
      <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
      Run Report
    </div>
  </div>

  <div
    *ngIf="reportHasRun"
    style="
      height: calc(100vh - 250px);
      overflow: auto;
      padding-bottom: 3rem;
      position: relative;
    "
    [ngStyle]="{ overflow: isLoading ? 'hidden' : 'auto' }"
  >
    <!--  report producers table-->
    <div class="report-product-wrapper mt-4">
      <h6>Producers</h6>

      <div class="no-table-report text-center mt-3" *ngIf="noDataFound">
        <div class="m-auto">
          <div class="img-container m-auto d-flex">
            <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
          </div>

          <p style="color: #9e9e9e" class="mt-4">
            There is no report available yet. <br />
            Please check back later
          </p>
        </div>
      </div>

      <div class="report-product-table mt-3" *ngIf="!noDataFound">
        <table class="table mb-0">
          <thead style="position: sticky; top: 0">
            <tr>
              <th width="25%">Producer Name</th>
              <th width="18%" class="text-end">Quantity Produced</th>
              <th width="18%" class="text-end">Total Value Produced</th>
              <th width="18%" class="text-end">Quantity Sold</th>
              <th width="21%" class="text-end">Total Sales</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let group of groupedSalePerProducerReportData"
            >
              <tr class="store-group-heading">
                <td colspan="5">{{ group.storeName }}</td>
              </tr>
              <tr *ngFor="let item of group.items">
                <td class="align-middle">
                  <p class="mb-0">{{ item.producerName }}</p>
                </td>
                <td class="align-middle text-end">
                  {{ item.quantityProduced | number }}
                </td>
                <td class="align-middle text-end">
                  {{ item.totalProductionValue | currency }}
                </td>
                <td class="align-middle text-end">
                  {{ item.totalItemsSold | number }}
                </td>
                <td class="align-middle text-end">
                  {{ item.totalSalesAmount | currency }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <!--loader-->
    <div class="overlay" *ngIf="isLoading">
      <div class="loader"></div>
    </div>
  </div>
</section>
